import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { getBusinessSiteGroups, getSite, updateSite } from '../../api';
import produce from 'immer';
import SubmitButtons from '../SubmitButtons';


/**
 * Site Settings.
 * @param {site, business, onComplete} props 
 */
function SiteSettings(props) {
  const { onComplete } = props;
  const [ site, setSite ] = useState(props.site);
  const [ siteGroups, setSiteGroups ] = useState(null);

  useEffect(() => {
    getSite(props.site.id)
      .then(res => {
        res.siteGroup = res.siteGroup.id;
        setSite(res);
      })
      .catch(err => {
        console.log(err);
      });
    
    getBusinessSiteGroups(props.business.id)
      .then(res => {
        setSiteGroups(res)
      })
      .catch(err => {
        console.log(err);
      });
  }, [props.site, props.business]);

  const edit = (key, val) => {
    setSite(produce(draftState => {
      draftState[key] = val;
      return draftState;
    }));
  }

  const save = () => {
    const { id, ...data } = site;
    updateSite(id, data);
    onComplete();
  }

  if (site == null || siteGroups == null) return null;

  return (
    <div>
      <Typography
        variant='h5'
        gutterBottom
      >
        Settings
      </Typography>

      {/* Site */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            variant='outlined'
            label='Name'
            fullWidth
            value={site.name}
            onChange={evt => edit('name', evt.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            variant='outlined'
            label='URL'
            fullWidth
            value={site.url}
            onChange={evt => edit('url', evt.target.value)}
          />
        </Grid>

        {/* Site Group */}
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            variant='outlined'
            label='Site Group'
            value={site.siteGroup}
            onChange={evt => edit('siteGroup', evt.target.value)}
            select
            fullWidth
          >
            {siteGroups.map(sg => (
              <MenuItem key={sg.id} value={sg.id}>
                {sg.name} ({sg.city})
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Site Options */}
        <Grid item xs={12} sm={6} md={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={site.publicView}
                onChange={(_, val) => edit('publicView', val)}
              />}
            label='Public View'
          />
        </Grid>
      </Grid>

      <SubmitButtons
        onSubmit={save}
        onCancel={onComplete}
      />
    </div>
  );
}

export default SiteSettings;
